document.getElementById('promo-close-bar').addEventListener('click', function() {
  // Remove class from element(s) with promo-banner-bar
  var bannerElements = document.getElementsByClassName('promo-banner-bar');
  for (var i = 0; i < bannerElements.length; i++) {
    bannerElements[i].classList.remove('promo-banner-bar');
  }

  // Hide the global promo banner
  var globalBanner = document.getElementById('global-promo-banner');
  if (globalBanner) {
    globalBanner.style.display = 'none';
  }
});
